export const FILTER_MODE = {
  date: 'date',
  month: 'month',
} as const

export const APPOINTMENTS_MODE = {
  timely: 'timely',
  planned: 'planned',
}
